"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Recording = function Recording(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "20",
    height: "20",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.4",
    d: "M15 6.25H5.00001C4.76989 6.25 4.58334 6.43655 4.58334 6.66667V13.3333C4.58334 13.5635 4.76989 13.75 5.00001 13.75H15C15.2301 13.75 15.4167 13.5635 15.4167 13.3333V6.66667C15.4167 6.43655 15.2301 6.25 15 6.25Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5 7.91663C11.3512 7.91663 10.4167 8.85121 10.4167 9.99996C10.4167 10.4686 10.5722 10.9015 10.8344 11.25H9.16562C9.42777 10.9015 9.58335 10.4686 9.58335 9.99996C9.58335 8.85121 8.64877 7.91663 7.50002 7.91663C6.35127 7.91663 5.41669 8.85121 5.41669 9.99996C5.41669 11.1487 6.35127 12.0833 7.50002 12.0833H12.5C13.6488 12.0833 14.5834 11.1487 14.5834 9.99996C14.5834 8.85121 13.6488 7.91663 12.5 7.91663H12.5ZM6.25 9.99996C6.25 9.3107 6.81074 8.74996 7.5 8.74996C8.18926 8.74996 8.75 9.3107 8.75 9.99996C8.75 10.6892 8.18926 11.25 7.5 11.25C6.81074 11.25 6.25 10.6892 6.25 9.99996ZM12.5 11.25C11.8108 11.25 11.25 10.6892 11.25 9.99996C11.25 9.31072 11.8108 8.74996 12.5 8.74996C13.1892 8.74996 13.75 9.3107 13.75 9.99996C13.75 10.6892 13.1892 11.25 12.5 11.25Z",
    fill: props.foregroundColor
  }));
};

Recording.defaultProps = {
  altText: "Recording",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Recording.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Recording;
exports.default = _default;